import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="w-full bg-foreground-900 pt-14 md:pt-20 pb-6 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <img
                src="https://readdy.ai/api/search-image?query=Minimalist%20modern%20abstract%20geometric%20logo%20icon%20for%20a%20file%20system%20cloud%20storage%20brand%2C%20clean%20simple%20shape%20with%20rounded%20corners%2C%20flat%20design%2C%20white%20transparent%20background%2C%20professional%20tech%20company%20identity%2C%20single%20symbol&width=200&height=200&seq=logo-tianyi-fs&orientation=squarish"
                alt="Tianyi Logo"
                className="w-8 h-8 md:w-10 md:h-10 object-contain brightness-0 invert"
              />
              <span className="font-heading text-3xl md:text-4xl font-bold text-background-50 tracking-tight">
                Tianyi
              </span>
            </div>
            <p className="mt-4 text-foreground-400 text-sm leading-relaxed max-w-sm">
              企业级云端文件管理与协作平台。安全、高效、智能，让每一份文件都发挥最大价值。
            </p>
            <div className="flex items-center gap-3 mt-6">
              <a
                href="#"
                className="w-9 h-9 rounded-full border border-foreground-700 flex items-center justify-center text-foreground-400 hover:text-background-50 hover:border-foreground-500 transition-all cursor-pointer"
              >
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a
                href="#"
                className="w-9 h-9 rounded-full border border-foreground-700 flex items-center justify-center text-foreground-400 hover:text-background-50 hover:border-foreground-500 transition-all cursor-pointer"
              >
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a
                href="#"
                className="w-9 h-9 rounded-full border border-foreground-700 flex items-center justify-center text-foreground-400 hover:text-background-50 hover:border-foreground-500 transition-all cursor-pointer"
              >
                <i className="ri-github-line text-sm"></i>
              </a>
              <a
                href="#"
                className="w-9 h-9 rounded-full border border-foreground-700 flex items-center justify-center text-foreground-400 hover:text-background-50 hover:border-foreground-500 transition-all cursor-pointer"
              >
                <i className="ri-mail-line text-sm"></i>
              </a>
            </div>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-xs font-semibold text-background-50 uppercase tracking-wider mb-4">
              产品
            </h4>
            <div className="flex flex-col gap-2.5">
              <a
                href="#features"
                className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer"
              >
                产品特性
              </a>
              <a
                href="#functions"
                className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer"
              >
                核心功能
              </a>
              <a
                href="#pricing"
                className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer"
              >
                定价方案
              </a>
            </div>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-xs font-semibold text-background-50 uppercase tracking-wider mb-4">
              公司
            </h4>
            <div className="flex flex-col gap-2.5">
              <Link
                to="/"
                className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer"
              >
                关于我们
              </Link>
              <a
                href="#"
                className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer"
              >
                加入我们
              </a>
              <a
                href="#"
                className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer"
              >
                新闻动态
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-xs font-semibold text-background-50 uppercase tracking-wider mb-4">
              联系我们
            </h4>
            <div className="flex flex-col gap-2.5">
              <a
                href="tel:400-888-9999"
                className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer"
              >
                400-888-9999
              </a>
              <a
                href="mailto:info@tianyi.art"
                className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer"
              >
                info@tianyi.art
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 md:mt-16 pt-6 border-t border-foreground-800/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} Tianyi 文件系统 版权所有
          </p>
          <div className="flex items-center gap-4 md:gap-6">
            <a
              href="https://beian.miit.gov.cn/"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="text-xs text-foreground-500 hover:text-background-50 transition-colors cursor-pointer"
            >
              粤ICP备2022043961号-3
            </a>
            <Link
              to="/"
              className="text-xs text-foreground-500 hover:text-background-50 transition-colors cursor-pointer"
            >
              隐私政策
            </Link>
            <Link
              to="/"
              className="text-xs text-foreground-500 hover:text-background-50 transition-colors cursor-pointer"
            >
              服务条款
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}